// src/EditChallenge.js
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

function EditChallenge() {
  const { id } = useParams(); // challenge id from URL
  const navigate = useNavigate();
  const [challenge, setChallenge] = useState(null);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  // Fetch challenge details by id
  useEffect(() => {
    fetch(`https://auth.fnrewards.com/api/admin/challenge?id=${id}`, {
      method: "GET",
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => {
        if (data.challenge) {
          setChallenge(data.challenge);
        } else {
          setError("Challenge not found");
        }
      })
      .catch(err => setError(err.message));
  }, [id]);

  const handleChange = (e) => {
    setChallenge({ ...challenge, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    try {
      const res = await fetch("https://auth.fnrewards.com/api/admin/challenge/edit", {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(challenge)
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || "Update failed");
      } else {
        setMessage("Challenge updated successfully");
        // Optionally, redirect back to manage page after a delay
        setTimeout(() => navigate("/admin/challenges"), 2000);
      }
    } catch (err) {
      setError(err.message);
    }
  };

  if (!challenge) return <div>Loading challenge data...</div>;

  return (
    <div style={{ padding: "20px" }}>
      <h1>Edit Challenge</h1>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {message && <p style={{ color: "green" }}>{message}</p>}
      <form onSubmit={handleSubmit}>
        <div>
          <label>Title:</label>
          <input name="title" value={challenge.title} onChange={handleChange} required />
        </div>
        <div>
          <label>Description:</label>
          <textarea name="description" value={challenge.description} onChange={handleChange} required />
        </div>
        <div>
          <label>Challenge Type:</label>
          <input name="challenge_type" value={challenge.challenge_type} onChange={handleChange} required />
        </div>
        <div>
          <label>Requirement:</label>
          <input name="requirement" type="number" value={challenge.requirement} onChange={handleChange} required />
        </div>
        <div>
          <label>Reward:</label>
          <input name="reward" type="number" value={challenge.reward} onChange={handleChange} required />
        </div>
        <div>
          <label>Repeat Interval:</label>
          <input name="repeat_interval" value={challenge.repeat_interval || ""} onChange={handleChange} placeholder="daily, weekly, etc." />
        </div>
        <div>
          <label>Active (1 for yes, 0 for no):</label>
          <input name="active" type="number" value={challenge.active} onChange={handleChange} required />
        </div>
        <div>
          <label>Stat Key:</label>
          <input name="stat_key" value={challenge.stat_key} onChange={handleChange} required />
        </div>
        <button type="submit">Save Changes</button>
      </form>
    </div>
  );
}

export default EditChallenge;